export default __webpack_public_path__ + "static/media/worldwideshipping.d9ebc13f.svg";